import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../shared';

import { ChatSharedModule } from '../domains/aya/chat-shared.module';
import { ChatPanelComponent } from '../domains/aya/components/chat-panel/chat-panel.component';
import { HeaderModule } from './header/header.module';
import { SidebarMenuModule } from './sidebar-menu/sidebar-menu.module';
import { ShellComponent } from './shell.component';

@NgModule({
  imports: [
    RouterModule,
    SharedModule,
    HeaderModule,
    SidebarMenuModule,
    ChatSharedModule
  ],
  declarations: [
    ShellComponent,
    ChatPanelComponent
  ]
})
export class ShellModule {}
